import React, { useState, useEffect, useContext, useRef } from 'react';
import { Container, Row, Col, Table, Badge, Button, Form } from 'react-bootstrap';
import {
  FaSearch, FaMapMarkerAlt, FaEdit, FaTrash, FaEye,
  FaToggleOn, FaToggleOff, FaBuilding, FaUsers,
  FaMoneyBillWave, FaCheckCircle, FaTimesCircle,
  FaFilter, FaPlus, FaUpload, FaTimes
} from 'react-icons/fa';
import AdminLayout from '../../../../layouts/admin/AdminLayout';
import Swal from 'sweetalert2';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/admin/dashboard/VenuesList.css';

const ModalForm = ({
  VenueName, setVenueName, City, setCity, Address, setAddress,
  GuestCapacity, setGuestCapacity, PricePerEvent, setPricePerEvent,
  BookingPolicy, setBookingPolicy, CoverPreview, AmenityInput,
  setAmenityInput, Amenities, handleAddAmenity, handleRemoveAmenity,
  SelectedServices, handleToggleService, handleCoverImage, handleCoverDrop,
  handleGalleryImages, GalleryImages, removeGalleryImage,
  coverInputRef, galleryInputRef, availableServices,
  venueErrors, setVenueErrors, regexChecker,
  validatePrice
}) => (
  <div className="av-modal-body-vls">

    <div className="av-section-vls">
      <div className="av-section-header-vls">
        <span className="av-section-icon-vls">ℹ️</span>
        <h5 className="av-section-title-vls">Venue Information</h5>
      </div>
      <Row className="g-3">

        <Col xs={12} md={6}>
          <div className="av-form-group-vls">
            <label className="av-label-vls">Venue Name <span className="av-required-vls">*</span></label>
            <input
              className={`av-input-vls ${venueErrors.venueName ? 'input-error' : ''}`}
              type="text"
              placeholder="e.g. Pearl Continental Hotel"
              value={VenueName}
              onChange={(e) => {
                setVenueName(e.target.value);
                setVenueErrors({
                  ...venueErrors,
                  venueName: e.target.value.trim() ? regexChecker('eventName', e.target.value) : 'Venue Name is required'
                });
              }}
            />
            {venueErrors.venueName && (
              <p style={{ color: 'red', fontSize: '13px' }}>{venueErrors.venueName}</p>
            )}
          </div>
        </Col>

        <Col xs={12} md={6}>
          <div className="av-form-group-vls">
            <label className="av-label-vls">City <span className="av-required-vls">*</span></label>
            <div className="av-input-icon-wrap-vls">
              <FaMapMarkerAlt className="av-input-icon-vls" />
              <select
                className={`av-select-vls ${venueErrors.city ? 'input-error' : ''}`}
                value={City}
                onChange={(e) => {
                  setCity(e.target.value);
                  setVenueErrors({ ...venueErrors, city: e.target.value ? '' : 'City is required' });
                }}
              >
                <option value="">Select City</option>
                <option value="Karachi">Karachi</option>
                <option value="Lahore">Lahore</option>
                <option value="Islamabad">Islamabad</option>
                <option value="Rawalpindi">Rawalpindi</option>
                <option value="Faisalabad">Faisalabad</option>
                <option value="Multan">Multan</option>
                <option value="Peshawar">Peshawar</option>
                <option value="Gujranwala">Gujranwala</option>
              </select>
            </div>
            {venueErrors.city && (
              <p style={{ color: 'red', fontSize: '13px' }}>{venueErrors.city}</p>
            )}
          </div>
        </Col>

        <Col xs={12}>
          <div className="av-form-group-vls">
            <label className="av-label-vls">Complete Address <span className="av-required-vls">*</span></label>
            <textarea
              className={`av-textarea-vls ${venueErrors.address ? 'input-error' : ''}`}
              rows={3}
              placeholder="Enter complete address with landmarks"
              value={Address}
              onChange={(e) => {
                setAddress(e.target.value);
                setVenueErrors({ ...venueErrors, address: e.target.value.trim() ? '' : 'Complete Address is required' });
              }}
            />
            {venueErrors.address && (
              <p style={{ color: 'red', fontSize: '13px' }}>{venueErrors.address}</p>
            )}
          </div>
        </Col>

        <Col xs={12} md={6}>
          <div className="av-form-group-vls">
            <label className="av-label-vls">Guest Capacity <span className="av-required-vls">*</span></label>
            <div className="av-input-icon-wrap-vls">
              <FaUsers className="av-input-icon-vls" />
              <input
                className={`av-input-vls av-input-with-icon-vls ${venueErrors.guestCapacity ? 'input-error' : ''}`}
                type="number"
                placeholder="e.g. 500"
                value={GuestCapacity}
                onChange={(e) => {
                  setGuestCapacity(e.target.value);
                  setVenueErrors({
                    ...venueErrors,
                    guestCapacity: e.target.value ? regexChecker('guestCount', e.target.value) : 'Guest Capacity is required'
                  });
                }}
              />
            </div>
            {venueErrors.guestCapacity && (
              <p style={{ color: 'red', fontSize: '13px' }}>{venueErrors.guestCapacity}</p>
            )}
          </div>
        </Col>

        <Col xs={12} md={6}>
          <div className="av-form-group-vls">
            <label className="av-label-vls">Amenities & Facilities</label>
            <div className="av-amenity-input-row-vls">
              <input className="av-input-vls" type="text" placeholder="e.g. Air Conditioning, Parking"
                value={AmenityInput}
                onChange={(e) => setAmenityInput(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleAddAmenity()} />
              <button className="av-amenity-add-btn-vls" onClick={handleAddAmenity}>+ Add</button>
            </div>
            {Amenities.length > 0 && (
              <div className="av-amenity-tags-vls">
                {Amenities.map((a, i) => (
                  <span key={i} className="av-amenity-tag-vls">
                    {a}<button onClick={() => handleRemoveAmenity(i)}>×</button>
                  </span>
                ))}
              </div>
            )}
          </div>
        </Col>

      </Row>
    </div>

    <div className="av-section-vls">
      <div className="av-section-header-vls">
        <span className="av-section-icon-vls">✅</span>
        <h5 className="av-section-title-vls">Available Services</h5>
      </div>
      <p className="av-section-desc-vls">Select the services available at this venue</p>
      <div className="av-services-grid-vls">
        {availableServices.map((service) => (
          <div
            key={service.key}
            className={`av-service-card-vls ${SelectedServices.includes(service.key) ? 'av-service-selected-vls' : ''}`}
            onClick={() => handleToggleService(service.key)}
          >
            <span className="av-service-icon-vls">{service.icon}</span>
            <span className="av-service-label-vls">{service.label}</span>
            {SelectedServices.includes(service.key) && <span className="av-service-check-vls">✓</span>}
          </div>
        ))}
      </div>
    </div>

    <div className="av-section-vls">
      <div className="av-section-header-vls">
        <span className="av-section-icon-vls">💰</span>
        <h5 className="av-section-title-vls">Pricing & Availability</h5>
      </div>
      <Row className="g-3">
        <Col xs={12} md={6}>
          <div className="av-form-group-vls">
            <label className="av-label-vls">Price Per Event (PKR) <span className="av-required-vls">*</span></label>
            <div className="av-input-icon-wrap-vls">
              <FaMoneyBillWave className="av-input-icon-vls" />
              <input
                className={`av-input-vls av-input-with-icon-vls ${venueErrors.pricePerEvent ? 'input-error' : ''}`}
                type="text"
                placeholder="e.g. 250,000"
                value={PricePerEvent}
                onChange={(e) => {
                  const raw = e.target.value.replace(/,/g, '');
                  if (raw === '' || /^\d+$/.test(raw)) {
                    const formatted = raw ? Number(raw).toLocaleString('en-PK') : '';
                    setPricePerEvent(formatted);
                    setVenueErrors({
                      ...venueErrors,
                      pricePerEvent: raw ? validatePrice(raw) : 'Price Per Event is required'
                    });
                  }
                }}
              />
            </div>
            {venueErrors.pricePerEvent && (
              <p style={{ color: 'red', fontSize: '13px' }}>{venueErrors.pricePerEvent}</p>
            )}
          </div>
        </Col>
        <Col xs={12}>
          <div className="av-form-group-vls">
            <label className="av-label-vls">Booking Policy & Terms</label>
            <textarea className="av-textarea-vls" rows={4}
              placeholder="Enter booking terms, cancellation policy, advance payment details, etc."
              value={BookingPolicy} onChange={(e) => setBookingPolicy(e.target.value)} />
          </div>
        </Col>
      </Row>
    </div>

    <div className="av-section-vls">
      <div className="av-section-header-vls">
        <span className="av-section-icon-vls">🖼️</span>
        <h5 className="av-section-title-vls">Venue Media</h5>
      </div>

      {/* Cover Image */}
      <div className="av-form-group-vls">
        <label className="av-label-vls">Cover Image <span className="av-required-vls">*</span></label>
        <div
          className={`av-cover-drop-vls ${CoverPreview ? 'av-cover-has-image-vls' : ''} ${venueErrors.coverImage ? 'input-error' : ''}`}
          onClick={() => coverInputRef.current.click()}
          onDrop={(e) => {
            handleCoverDrop(e);
            setVenueErrors({ ...venueErrors, coverImage: '' });
          }}
          onDragOver={(e) => e.preventDefault()}
        >
          {CoverPreview ? (
            <img src={CoverPreview} alt="Cover" className="av-cover-preview-vls" />
          ) : (
            <>
              <FaUpload className="av-upload-icon-vls" />
              <p className="av-upload-text-vls">Upload Cover Image</p>
              <p className="av-upload-hint-vls">Click to browse or drag and drop • Max 5MB</p>
            </>
          )}
        </div>
        <input
          ref={coverInputRef}
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={(e) => {
            handleCoverImage(e);
            setVenueErrors({ ...venueErrors, coverImage: e.target.files[0] ? '' : 'Cover Image is required' });
          }}
        />
        {venueErrors.coverImage && (
          <p style={{ color: 'red', fontSize: '13px' }}>{venueErrors.coverImage}</p>
        )}
      </div>

      {/* Gallery Images — max 5 */}
      <div className="av-form-group-vls" style={{ marginTop: '16px' }}>
        <label className="av-label-vls">
          Gallery Images <span style={{ color: '#6b7280', fontSize: '13px' }}>(Max 5 images)</span>
        </label>

        {/* Gallery preview grid */}
        {GalleryImages.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '12px' }}>
            {GalleryImages.map((img, i) => (
              <div key={i} style={{ position: 'relative', width: '90px', height: '90px' }}>
                <img
                  src={typeof img === 'string' ? img : URL.createObjectURL(img)}
                  alt={`gallery-${i}`}
                  style={{ width: '90px', height: '90px', objectFit: 'cover', borderRadius: '8px', border: '2px solid #e5e7eb' }}
                />
                <button
                  onClick={() => removeGalleryImage(i)}
                  style={{
                    position: 'absolute', top: '-6px', right: '-6px',
                    background: '#ef4444', color: '#fff', border: 'none',
                    borderRadius: '50%', width: '20px', height: '20px',
                    fontSize: '12px', cursor: 'pointer', display: 'flex',
                    alignItems: 'center', justifyContent: 'center'
                  }}
                >×</button>
              </div>
            ))}
          </div>
        )}

        {/* Upload button — only show if less than 5 */}
        {GalleryImages.length < 5 && (
          <div
            className="av-cover-drop-vls"
            onClick={() => galleryInputRef.current.click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const files = Array.from(e.dataTransfer.files);
              const remaining = 5 - GalleryImages.length;
              const allowed = files.slice(0, remaining);
              handleGalleryImages({ target: { files: allowed } });
            }}
            style={{ minHeight: '80px' }}
          >
            <FaUpload className="av-upload-icon-vls" />
            <p className="av-upload-text-vls">Upload Gallery Images</p>
            <p className="av-upload-hint-vls">
              {GalleryImages.length}/5 uploaded • Click or drag & drop • Max 5MB each
            </p>
          </div>
        )}

        <input
          ref={galleryInputRef}
          type="file"
          accept="image/*"
          multiple
          style={{ display: 'none' }}
          onChange={(e) => {
            const files = Array.from(e.target.files);
            const remaining = 5 - GalleryImages.length;
            const allowed = files.slice(0, remaining);
            handleGalleryImages({ target: { files: allowed } });
          }}
        />
        {GalleryImages.length >= 5 && (
          <p style={{ color: '#f59e0b', fontSize: '13px', marginTop: '6px' }}>
            ⚠️ Maximum 5 images uploaded. Remove one to add another.
          </p>
        )}
      </div>

    </div>
  </div>
);

const VenuesList = () => {

  const { baseUrl, regexChecker } = useContext(AppContext);

  const [VenueName, setVenueName] = useState('');
  const [City, setCity] = useState('');
  const [Address, setAddress] = useState('');
  const [GuestCapacity, setGuestCapacity] = useState('');
  const [PricePerEvent, setPricePerEvent] = useState('');
  const [BookingPolicy, setBookingPolicy] = useState('');
  const [CoverImage, setCoverImage] = useState(null);
  const [CoverPreview, setCoverPreview] = useState(null);
  const [GalleryImages, setGalleryImages] = useState([]);
  const [Amenities, setAmenities] = useState([]);
  const [AmenityInput, setAmenityInput] = useState('');
  const [SelectedServices, setSelectedServices] = useState([]);

  const [venueErrors, setVenueErrors] = useState({
    venueName: '',
    city: '',
    address: '',
    guestCapacity: '',
    pricePerEvent: '',
    coverImage: ''
  });

  const [venues, setVenues] = useState([]);
  const [filteredVenues, setFilteredVenues] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCity, setFilterCity] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editVenue, setEditVenue] = useState({});
  const [addBtnLoading, setAddBtnLoading] = useState(false);

  const coverInputRef = useRef(null);
  const galleryInputRef = useRef(null);

  const availableServices = [
    { key: 'catering',    label: 'Catering',            icon: '🍽️' },
    { key: 'decoration',  label: 'Decoration',          icon: '🎨' },
    { key: 'photography', label: 'Photography',         icon: '📷' },
    { key: 'videography', label: 'Videography',         icon: '🎥' },
    { key: 'music',       label: 'Music & DJ',          icon: '🎵' },
    { key: 'lighting',    label: 'Lighting Setup',      icon: '💡' },
    { key: 'security',    label: 'Security Staff',      icon: '🛡️' },
    { key: 'valet',       label: 'Valet Parking',       icon: '🚗' },
    { key: 'floral',      label: 'Floral Arrangements', icon: '🌸' },
    { key: 'cake',        label: 'Wedding Cake',        icon: '🎂' },
    { key: 'makeup',      label: 'Bridal Makeup',       icon: '💄' },
    { key: 'invitation',  label: 'Invitation Cards',    icon: '✉️' },
  ];

  // ── Price validation — plain number ──
  const validatePrice = (value) => {
    const raw = String(value).replace(/,/g, '');
    if (!raw) return 'Price Per Event is required';
    if (isNaN(Number(raw)) || Number(raw) <= 0) return 'Price must be a valid number e.g. 250,000';
    return '';
  };

  const viewAllVenues = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/venue/viewAllVenue`)
      .then((res) => {
        setVenues(res.data);
        setFilteredVenues(res.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    viewAllVenues();
  }, []);

  const cities = [...new Set(venues.map(v => v.city))];

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    filterVenues(value, filterCity, filterStatus);
  };

  const handleCityFilter = (e) => {
    const value = e.target.value;
    setFilterCity(value);
    filterVenues(searchTerm, value, filterStatus);
  };

  const handleStatusFilter = (e) => {
    const value = e.target.value;
    setFilterStatus(value);
    filterVenues(searchTerm, filterCity, value);
  };

  const filterVenues = (search, city, status) => {
    let filtered = venues;
    if (search) filtered = filtered.filter(v =>
      v.venueName.toLowerCase().includes(search) ||
      v.location?.toLowerCase().includes(search) ||
      v.city.toLowerCase().includes(search)
    );
    if (city)   filtered = filtered.filter(v => v.city === city);
    if (status) filtered = filtered.filter(v => v.status === status);
    setFilteredVenues(filtered);
  };

  const handleResetFilters = () => {
    setSearchTerm('');
    setFilterCity('');
    setFilterStatus('');
    setFilteredVenues(venues);
  };

  const resetVenueErrors = () => {
    setVenueErrors({
      venueName: '',
      city: '',
      address: '',
      guestCapacity: '',
      pricePerEvent: '',
      coverImage: ''
    });
  };

  const validateVenueForm = () => {
    const rawPrice = String(PricePerEvent).replace(/,/g, '');
    const errors = {
      venueName:     VenueName.trim() ? regexChecker('eventName', VenueName) : 'Venue Name is required',
      city:          City ? '' : 'City is required',
      address:       Address.trim() ? '' : 'Complete Address is required',
      guestCapacity: GuestCapacity ? regexChecker('guestCount', GuestCapacity) : 'Guest Capacity is required',
      pricePerEvent: validatePrice(rawPrice),
      coverImage:    (CoverImage || CoverPreview) ? '' : 'Cover Image is required'
    };

    setVenueErrors(errors);
    return Object.values(errors).some((err) => err);
  };

  const resetForm = () => {
    setVenueName('');
    setCity('');
    setAddress('');
    setGuestCapacity('');
    setPricePerEvent('');
    setBookingPolicy('');
    setCoverImage(null);
    setCoverPreview(null);
    setGalleryImages([]);
    setAmenities([]);
    setAmenityInput('');
    setSelectedServices([]);
  };

  const handleOpenAddModal = () => {
    resetForm();
    resetVenueErrors();
    setShowAddModal(true);
  };

  const handleAddVenueClick = () => {
    setAddBtnLoading(true);
    setTimeout(() => {
      handleOpenAddModal();
      setAddBtnLoading(false);
    }, 600);
  };

  const handleOpenEdit = (venue) => {
    setEditVenue(venue);
    setVenueName(venue.venueName);
    setCity(venue.city);
    setAddress(venue.location || '');
    setGuestCapacity(venue.capacity || '');
    // Edit mein price comma format mein dikhao
    const formattedPrice = venue.priceRange
      ? Number(String(venue.priceRange).replace(/,/g, '')).toLocaleString('en-PK')
      : '';
    setPricePerEvent(formattedPrice);
    setBookingPolicy('');
    setCoverImage(null);
    setCoverPreview(venue.coverImage || null);
    setGalleryImages([]);
    setAmenities(Array.isArray(venue.amenities) ? venue.amenities : []);
    setAmenityInput('');
    setSelectedServices([]);
    resetVenueErrors();
    setShowEditModal(true);
  };

  const handleCoverImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCoverImage(file);
      setCoverPreview(URL.createObjectURL(file));
    }
  };

  const handleCoverDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      setCoverImage(file);
      setCoverPreview(URL.createObjectURL(file));
    }
  };

  const handleGalleryImages = (e) => {
    const files = Array.from(e.target.files);
    setGalleryImages(prev => {
      const remaining = 5 - prev.length;
      return [...prev, ...files.slice(0, remaining)];
    });
  };

  const removeGalleryImage = (index) => {
    setGalleryImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleAddAmenity = () => {
    if (AmenityInput.trim()) {
      setAmenities(prev => [...prev, AmenityInput.trim()]);
      setAmenityInput('');
    }
  };

  const handleRemoveAmenity = (index) => {
    setAmenities(prev => prev.filter((_, i) => i !== index));
  };

  const handleToggleService = (key) => {
    setSelectedServices(prev =>
      prev.includes(key) ? prev.filter(s => s !== key) : [...prev, key]
    );
  };

  const handleSaveAdd = () => {
    const hasErrors = validateVenueForm();
    if (hasErrors) {
      Swal.fire({ icon: 'warning', title: 'Required Fields', text: 'Please fix the highlighted fields', confirmButtonColor: '#7C6FDC' });
      return;
    }

    setIsSubmitting(true);
    const rawPrice = String(PricePerEvent).replace(/,/g, '');

    const formData = new FormData();
    formData.append('venueName',     VenueName);
    formData.append('city',          City);
    formData.append('address',       Address);
    formData.append('guestCapacity', GuestCapacity);
    formData.append('pricePerEvent', rawPrice);
    formData.append('bookingPolicy', BookingPolicy);
    formData.append('services',      JSON.stringify(SelectedServices));
    formData.append('amenities',     JSON.stringify(Amenities));
    if (CoverImage) formData.append('coverImage', CoverImage);
    GalleryImages.forEach((img, i) => {
      if (img instanceof File) formData.append(`gallery_${i}`, img);
    });

    axios
      .post(`${baseUrl}/admin/venue/createVenue`, formData)
      .then((res) => {
        console.log(res.data);
        viewAllVenues();
        setShowAddModal(false);
        resetForm();
        resetVenueErrors();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsSubmitting(false));
  };

  const handleSaveEdit = () => {
    const hasErrors = validateVenueForm();
    if (hasErrors) {
      Swal.fire({ icon: 'warning', title: 'Required Fields', text: 'Please fix the highlighted fields', confirmButtonColor: '#7C6FDC' });
      return;
    }

    setIsSubmitting(true);
    const rawPrice = String(PricePerEvent).replace(/,/g, '');

    const formData = new FormData();
    formData.append('id',            editVenue.id);
    formData.append('venueName',     VenueName);
    formData.append('city',          City);
    formData.append('address',       Address);
    formData.append('guestCapacity', GuestCapacity);
    formData.append('pricePerEvent', rawPrice);
    formData.append('bookingPolicy', BookingPolicy);
    formData.append('services',      JSON.stringify(SelectedServices));
    formData.append('amenities',     JSON.stringify(Amenities));
    if (CoverImage) formData.append('coverImage', CoverImage);
    GalleryImages.forEach((img, i) => {
      if (img instanceof File) formData.append(`gallery_${i}`, img);
    });

    axios
      .post(`${baseUrl}/admin/venue/updateVenue`, formData)
      .then((res) => {
        console.log(res.data);
        viewAllVenues();
        setShowEditModal(false);
        resetForm();
        resetVenueErrors();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsSubmitting(false));
  };

  const handleDeleteVenue = (venue) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete ${venue.venueName}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${baseUrl}/admin/venue/deleteVenue/${venue.id}`)
          .then((res) => {
            console.log(res.data);
            viewAllVenues();
            Swal.fire({ title: 'Deleted!', icon: 'success', confirmButtonColor: '#28a745' });
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const handleViewDetails = (venue) => {
    Swal.fire({
      title: venue.venueName,
      html: `
        <div style="text-align:left;padding:20px;">
          <p><strong>📍 Location:</strong> ${venue.location}, ${venue.city}</p>
          <p><strong>👥 Capacity:</strong> ${venue.capacity} guests</p>
          <p><strong>💰 Price Range:</strong> Rs. ${venue.priceRange}</p>
          <p><strong>🎯 Status:</strong>
            <span style="color:${venue.status === 'active' ? '#28a745' : '#dc3545'};font-weight:bold;">
              ${venue.status.toUpperCase()}
            </span>
          </p>
          <p><strong>🏷️ Amenities:</strong> ${Array.isArray(venue.amenities) ? venue.amenities.join(', ') : venue.amenities}</p>
        </div>
      `,
      icon: 'info',
      confirmButtonColor: '#7C6FDC',
      width: 600
    });
  };

  const handleToggleStatus = (venue) => {
    const newStatus  = venue.status === 'active' ? 'inactive' : 'active';
    const statusText = newStatus   === 'active'  ? 'activate' : 'deactivate';
    Swal.fire({
      title: `${statusText.charAt(0).toUpperCase() + statusText.slice(1)} Venue?`,
      text: `Do you want to ${statusText} ${venue.venueName}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#7C6FDC',
      cancelButtonColor: '#6c757d',
      confirmButtonText: `Yes, ${statusText}!`
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append('id',     venue.id);
        formData.append('status', newStatus);
        axios
          .post(`${baseUrl}/admin/venue/updateVenueStatus`, formData)
          .then(() => viewAllVenues())
          .catch((err) => console.log(err));
      }
    });
  };

  const actionBtn    = { width: '34px', height: '34px', padding: '0', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '14px', color: '#ffffff', transition: 'transform 0.18s ease, opacity 0.18s ease' };
  const viewBtn      = { ...actionBtn, background: 'linear-gradient(135deg, #3b82f6, #60a5fa)', boxShadow: '0 3px 10px rgba(59,130,246,0.40)'  };
  const editBtn      = { ...actionBtn, background: 'linear-gradient(135deg, #f59e0b, #fbbf24)', boxShadow: '0 3px 10px rgba(245,158,11,0.40)'  };
  const toggleOnBtn  = { ...actionBtn, background: 'linear-gradient(135deg, #6b7280, #9ca3af)', boxShadow: '0 3px 10px rgba(107,114,128,0.40)' };
  const toggleOffBtn = { ...actionBtn, background: 'linear-gradient(135deg, #10b981, #34d399)', boxShadow: '0 3px 10px rgba(16,185,129,0.40)'  };
  const deleteBtn    = { ...actionBtn, background: 'linear-gradient(135deg, #ef4444, #f87171)', boxShadow: '0 3px 10px rgba(239,68,68,0.40)'   };
  const hoverUp   = (e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.opacity = '0.88'; };
  const hoverDown = (e) => { e.currentTarget.style.transform = 'translateY(0)';    e.currentTarget.style.opacity = '1';    };

  const modalProps = {
    VenueName, setVenueName, City, setCity, Address, setAddress,
    GuestCapacity, setGuestCapacity, PricePerEvent, setPricePerEvent,
    BookingPolicy, setBookingPolicy, CoverPreview, AmenityInput,
    setAmenityInput, Amenities, handleAddAmenity, handleRemoveAmenity,
    SelectedServices, handleToggleService, handleCoverImage, handleCoverDrop,
    handleGalleryImages, GalleryImages, removeGalleryImage,
    coverInputRef, galleryInputRef, availableServices,
    venueErrors, setVenueErrors, regexChecker, validatePrice
  };

  return (
    <AdminLayout>
      <div className="venues-list-page-vls">

        <div className="page-header-vls">
          <div className="header-content-vls">
            <h1 className="page-title-vls"><FaBuilding className="title-icon-vls" /> Venues List</h1>
            <p className="page-subtitle-vls">Manage all wedding venues and their availability</p>
          </div>
          <button className="add-venue-btn-vls" onClick={handleAddVenueClick} disabled={addBtnLoading}>
            {addBtnLoading ? (
              <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Loading...</>
            ) : (
              <><FaPlus /> Add New Venue</>
            )}
          </button>
        </div>

        <Row className="statistics-section-vls">
          <Col md={3}>
            <div className="stat-card-vls card-total-vls">
              <div className="stat-icon-vls"><FaBuilding /></div>
              <div className="stat-content-vls"><h3>{venues.length}</h3><p>Total Venues</p></div>
            </div>
          </Col>
          <Col md={3}>
            <div className="stat-card-vls card-active-vls">
              <div className="stat-icon-vls"><FaCheckCircle /></div>
              <div className="stat-content-vls"><h3>{venues.filter(v => v.status === 'active').length}</h3><p>Active Venues</p></div>
            </div>
          </Col>
          <Col md={3}>
            <div className="stat-card-vls card-inactive-vls">
              <div className="stat-icon-vls"><FaTimesCircle /></div>
              <div className="stat-content-vls"><h3>{venues.filter(v => v.status === 'inactive').length}</h3><p>Inactive Venues</p></div>
            </div>
          </Col>
          <Col md={3}>
            <div className="stat-card-vls card-cities-vls">
              <div className="stat-icon-vls"><FaMapMarkerAlt /></div>
              <div className="stat-content-vls"><h3>{cities.length}</h3><p>Cities Covered</p></div>
            </div>
          </Col>
        </Row>

        <div className="filters-section-vls">
          <Row className="g-3">
            <Col md={12} lg={4}>
              <div className="search-box-vls">
                <FaSearch className="search-icon-vls" />
                <Form.Control type="text" placeholder="Search by venue name, location..."
                  value={searchTerm} onChange={handleSearch} className="search-input-vls" />
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="filter-box-vls">
                <FaMapMarkerAlt className="filter-icon-vls" />
                <Form.Select value={filterCity} onChange={handleCityFilter} className="filter-select-vls">
                  <option value="">All Cities</option>
                  {cities.map((city, i) => <option key={i} value={city}>{city}</option>)}
                </Form.Select>
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="filter-box-vls">
                <FaFilter className="filter-icon-vls" />
                <Form.Select value={filterStatus} onChange={handleStatusFilter} className="filter-select-vls">
                  <option value="">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </div>
            </Col>
            <Col lg={2}>
              <Button variant="outline-secondary" className="reset-btn-vls" onClick={handleResetFilters}>
                <FaFilter /> Reset
              </Button>
            </Col>
          </Row>
          <div className="results-info-vls">
            <span className="count-badge-vls">{filteredVenues.length} Venues Found</span>
          </div>
        </div>

        <div className="venues-table-container-vls">
          {loading ? (
            <div className="loading-state-vls">
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
              <p>Loading venues...</p>
            </div>
          ) : filteredVenues.length === 0 ? (
            <div className="empty-state-vls">
              <FaTimesCircle className="empty-icon-vls" />
              <h3>No Venues Found</h3>
              <p>Try adjusting your search or filter criteria</p>
            </div>
          ) : (
            <div className="table-responsive-vls">
              <Table className="venues-table-vls" hover>
                <thead className="table-head-vls">
                  <tr>
                    <th className="table-header-vls">#</th>
                    <th className="table-header-vls">Image</th>
                    <th className="table-header-vls">Venue Name</th>
                    <th className="table-header-vls">City / Location</th>
                    <th className="table-header-vls">Capacity</th>
                    <th className="table-header-vls">Price Range</th>
                    <th className="table-header-vls">Status</th>
                    <th className="table-header-vls text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="table-body-vls">
                  {filteredVenues.map((venue, index) => (
                    <tr key={venue.id} className="table-row-vls">
                      <td className="table-cell-vls">{index + 1}</td>
                      <td className="table-cell-vls">
                        {venue.coverImage ? (
                          <img src={venue.coverImage} alt={venue.venueName} className="venue-thumb-img-vls" />
                        ) : (
                          <div className="venue-thumb-placeholder-vls"><FaBuilding /></div>
                        )}
                      </td>
                      <td className="table-cell-vls">
                        <div className="venue-name-cell-vls">
                          <span className="venue-name-vls">{venue.venueName}</span>
                        </div>
                      </td>
                      <td className="table-cell-vls">
                        <div className="location-cell-vls">
                          <FaMapMarkerAlt className="location-icon-vls" />
                          <div>
                            <span className="city-vls">{venue.city}</span>
                            <span className="address-vls">{venue.location}</span>
                          </div>
                        </div>
                      </td>
                      <td className="table-cell-vls">
                        <span className="capacity-badge-vls"><FaUsers className="me-1" />{venue.capacity}</span>
                      </td>
                      <td className="table-cell-vls">
                        <span className="price-range-vls"><FaMoneyBillWave className="me-1" />Rs. {venue.priceRange}</span>
                      </td>
                      <td className="table-cell-vls">
                        {venue.status === 'active' ? (
                          <Badge bg="success" className="status-badge-vls"><FaCheckCircle /> Active</Badge>
                        ) : (
                          <Badge bg="danger" className="status-badge-vls"><FaTimesCircle /> Inactive</Badge>
                        )}
                      </td>
                      <td className="table-cell-vls text-center">
                        <div className="action-buttons-vls">
                          <button style={viewBtn}   title="View"   onClick={() => handleViewDetails(venue)} onMouseEnter={hoverUp} onMouseLeave={hoverDown}><FaEye /></button>
                          <button style={editBtn}   title="Edit"   onClick={() => handleOpenEdit(venue)}    onMouseEnter={hoverUp} onMouseLeave={hoverDown}><FaEdit /></button>
                          <button style={venue.status === 'active' ? toggleOnBtn : toggleOffBtn}
                            title={venue.status === 'active' ? 'Deactivate' : 'Activate'}
                            onClick={() => handleToggleStatus(venue)} onMouseEnter={hoverUp} onMouseLeave={hoverDown}>
                            {venue.status === 'active' ? <FaToggleOff /> : <FaToggleOn />}
                          </button>
                          <button style={deleteBtn} title="Delete" onClick={() => handleDeleteVenue(venue)} onMouseEnter={hoverUp} onMouseLeave={hoverDown}><FaTrash /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>

        {/* Add Modal */}
        {showAddModal && (
          <div className="av-modal-overlay-vls" onClick={() => setShowAddModal(false)}>
            <div className="av-modal-box-vls" onClick={(e) => e.stopPropagation()}>
              <div className="av-modal-header-vls">
                <div className="av-modal-title-wrap-vls">
                  <FaBuilding className="av-modal-title-icon-vls" />
                  <div>
                    <h4 className="av-modal-title-vls">Add New Venue</h4>
                    <p className="av-modal-subtitle-vls">Fill in the details to add a new wedding venue</p>
                  </div>
                </div>
                <button className="av-modal-close-vls" onClick={() => setShowAddModal(false)}><FaTimes /></button>
              </div>
              <ModalForm {...modalProps} />
              <div className="av-modal-footer-vls">
                <button className="av-cancel-btn-vls" onClick={() => setShowAddModal(false)}><FaTimes /> Cancel</button>
                <button className="av-save-btn-vls" onClick={handleSaveAdd} disabled={isSubmitting}>
                  {isSubmitting ? 'Saving...' : '✓ Save Venue'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {showEditModal && (
          <div className="av-modal-overlay-vls" onClick={() => setShowEditModal(false)}>
            <div className="av-modal-box-vls" onClick={(e) => e.stopPropagation()}>
              <div className="av-modal-header-vls">
                <div className="av-modal-title-wrap-vls">
                  <FaBuilding className="av-modal-title-icon-vls" />
                  <div>
                    <h4 className="av-modal-title-vls">Edit Venue</h4>
                    <p className="av-modal-subtitle-vls">Update the details of this venue</p>
                  </div>
                </div>
                <button className="av-modal-close-vls" onClick={() => setShowEditModal(false)}><FaTimes /></button>
              </div>
              <ModalForm {...modalProps} />
              <div className="av-modal-footer-vls">
                <button className="av-cancel-btn-vls" onClick={() => setShowEditModal(false)}><FaTimes /> Cancel</button>
                <button className="av-save-btn-vls" onClick={handleSaveEdit} disabled={isSubmitting}>
                  {isSubmitting ? 'Updating...' : '✓ Update Venue'}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </AdminLayout>
  );
};

export default VenuesList;